@if (hasItems) {
  <section class="expiring-section" data-cy="expiring-section">
    <h2 class="expiring-title" style="font-size: 120%">
      {{ 'expiring.header' | translate }}
    </h2>
    <div class="expiring-body">
      <p-tabs [value]="activeTab" (valueChange)="onTabChange($event)">
        <p-tablist>
          <p-tab value="contracts">
            {{ 'expiring.tab-contracts' | translate }} ({{ contracts.length }})
          </p-tab>
          <p-tab value="infections" data-cy="expiring-tab-infections">
            {{ 'expiring.tab-infections' | translate }} ({{
              infections.length
            }})
          </p-tab>
        </p-tablist>

        <p-tabpanel value="contracts">
          @if (contracts.length === 0) {
            <p class="text-600 text-sm m-2">
              {{ 'expiring.no-contracts' | translate }}
            </p>
          } @else {
            <p-table
              [value]="contracts"
              [styleClass]="'p-datatable-sm p-datatable-striped'"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>{{ 'expiring.col-customer' | translate }}</th>
                  <th>{{ 'expiring.col-contract-number' | translate }}</th>
                  <th>{{ 'expiring.col-contract-type' | translate }}</th>
                  <th>{{ 'expiring.col-validity' | translate }}</th>
                  <th>{{ 'expiring.col-status' | translate }}</th>
                  <th>{{ 'expiring.col-comment' | translate }}</th>
                  <th class="text-right">
                    {{ 'expiring.col-actions' | translate }}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-contract>
                <tr>
                  <td>{{ contract.customerName }}</td>
                  <td>{{ contract.contractId }}</td>
                  <td>
                    {{
                      contract.contractTypeDescription || contract.contractType
                    }}
                  </td>
                  <td class="white-space-nowrap">
                    {{ contract.startDate | appDate: 'shortDate' }} -
                    {{ contract.endDate | appDate: 'shortDate' }}
                  </td>
                  <td>
                    <span
                      class="inline-flex align-items-center px-2 py-1 border-round text-sm font-bold bg-orange-100 text-orange-700"
                    >
                      {{ 'contracts.expiring' | translate }}
                    </span>
                  </td>
                  <td>{{ contract.contractComment }}</td>
                  <td class="text-right white-space-nowrap">
                    <button
                      pButton
                      type="button"
                      icon="pi pi-times"
                      class="p-button-text p-button-danger p-button-sm"
                      [pTooltip]="'expiring.remove' | translate"
                      (click)="removeContract(contract, $event)"
                    ></button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          }
        </p-tabpanel>

        <p-tabpanel value="infections">
          @if (infections.length === 0) {
            <p class="text-600 text-sm m-2">
              {{ 'expiring.no-infections' | translate }}
            </p>
          } @else {
            <p-table
              [value]="infections"
              [styleClass]="'p-datatable-sm p-datatable-striped'"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>{{ 'expiring.col-customer' | translate }}</th>
                  <th>{{ 'expiring.col-type' | translate }}</th>
                  <th>{{ 'expiring.col-valid-until' | translate }}</th>
                  <th>{{ 'expiring.col-days-to-expiry' | translate }}</th>
                  <th>{{ 'expiring.col-result' | translate }}</th>
                  <th class="text-right">
                    {{ 'expiring.col-actions' | translate }}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-infection>
                <tr data-cy="expiring-infection-row" [attr.data-key]="infection.key">
                  <td>{{ infection.customerName }}</td>
                  <td>{{ 'expiring.type-' + infection.type | translate }}</td>
                  <td class="white-space-nowrap">
                    {{ infection.validUntil | appDate: 'shortDate' }}
                  </td>
                  <td
                    [class.text-red-600]="infection.daysToExpiry < 0"
                    [class.font-bold]="infection.daysToExpiry < 0"
                  >
                    {{ infection.daysToExpiry }}
                  </td>
                  <td>
                    @if (infection.result) {
                      {{ 'ivf.checklist.' + infection.result | translate }}
                    } @else {
                      -
                    }
                  </td>
                  <td class="text-right white-space-nowrap">
                    <button
                      pButton
                      type="button"
                      icon="pi pi-times"
                      class="p-button-text p-button-danger p-button-sm"
                      [pTooltip]="'expiring.remove' | translate"
                      data-cy="expiring-infection-remove"
                      (click)="removeInfection(infection, $event)"
                    ></button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          }
        </p-tabpanel>
      </p-tabs>
    </div>
  </section>
}
